import { render, staticRenderFns } from "./TailoredLeadsForm.vue?vue&type=template&id=3fb20985&"
import script from "./TailoredLeadsForm.vue?vue&type=script&lang=js&"
export * from "./TailoredLeadsForm.vue?vue&type=script&lang=js&"
import style0 from "./TailoredLeadsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports